import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ICampaign } from '@/api/routes/campaigns/types';
import type { ResponseWithPagination } from '@/utils/types';

import { fetchAds } from './actionCreators';

interface InitialState {
  ads: ICampaign [],
  offset: number,
  totalCount: number,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  ads: [],
  offset: 0,
  totalCount: 0,
  isLoading: false,
  error: '',
};

export const adsSlice = createSlice({
  name: 'ads',
  initialState,
  reducers: {
    toggleAdStatus: (state, action: PayloadAction<{ id: string }>) => {
      const campIndex = state.ads.map((camp) => camp.ads[0].id).findIndex((id) => id === action.payload.id);
      state.ads[campIndex].ads[0].enabled = !state.ads[campIndex].ads[0].enabled;
    },
    toggleAdOrgStatus: (state, action: PayloadAction<{ id: string }>) => {
      const campIndex = state.ads.map((camp) => camp.ads[0].id).findIndex((id) => id === action.payload.id);
      state.ads[campIndex].ads[0].org_enabled = !state.ads[campIndex].ads[0].org_enabled;
    },
    toggleAdminModerationAd: (state, action: PayloadAction<{
      id: string, adminModState: number
    }>) => {
      const campIndex = state.ads.findIndex(
        (camp: any) => (camp.ads?.[0]?.id ?? camp.id) === action.payload.id,
      );
      if (campIndex === -1) return;
      const item = state.ads[campIndex];
      if (item.ads?.[0]) {
        item.ads[0].admin_mod_state = action.payload.adminModState;
      } else {
        item.admin_mod_state = action.payload.adminModState;
      }
    },
    retryModerationAd: (state, action: PayloadAction<{ id: string }>) => {
      const campIndex = state.ads.map((camp) => camp.ads[0].id).findIndex((id) => id === action.payload.id);
      state.ads[campIndex].ads[0].mod_state = -1;
    },
    forceModerationAd: (state, action: PayloadAction<{ id: string }>) => {
      const campIndex = state.ads.map((camp) => camp.ads[0].id).findIndex((id) => id === action.payload.id);
      state.ads[campIndex].ads[0].mod_force_yes = !state.ads[campIndex].ads[0].mod_force_yes;
    },
  },
  extraReducers: {
    [fetchAds.fulfilled.type]: (state, action: PayloadAction<ResponseWithPagination<ICampaign>>) => {
      state.isLoading = false;
      state.error = '';
      state.ads = action.payload.rows;
      state.offset = action.payload.offset;
      state.totalCount = action.payload.total_count;
    },
    [fetchAds.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchAds.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  toggleAdStatus,
  toggleAdOrgStatus,
  toggleAdminModerationAd,
  retryModerationAd,
  forceModerationAd,
} = adsSlice.actions;
export default adsSlice.reducer;
